// extracted by mini-css-extract-plugin
export var dividerLine = "_67-3";
export var itemImage = "_67-9";
export var lightDivider = "_67-4";
export var modalContent = "_67-5";
export var modalContentCompact = "_67-6";
export var productCard = "_67-a";
export var productImage = "_67-b";
export var productImageCompact = "_67-7";
export var productImagePlaceholder = "_67-c";
export var productImagePlaceholderCompact = "_67-8";
export var progressBarBackground = "_67-1";
export var progressBarContainer = "_67-0";
export var progressBarFill = "_67-2";